export default __webpack_public_path__ + "static/media/13.d22029b6.jpg";